import { IModel } from '../base/annotation';
import { ExpressCustomSetup } from './expressCustomSetup';
import { ComponentSetup, isLicensedComponent, supportedComponentNames } from './componentSetup';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { stringIsNullOrEmpty } from '../../shared/utils/string.util';
import { Metamodel } from '../base/model';

@Metamodel.model({
    name: 'LicensedComponentSetup',
    display: [shellStringResources.ModelName_LicensedComponentExtension, shellStringResources.ModelName_LicensedComponentExtensions]
})
export class LicensedComponentSetup extends ComponentSetup {
    public static readonly MODEL: IModel;
    public static readonly licenseKeyKingswaySoft: RegExp = /^([*]{10}|([A-Z0-9]{5}-){5}[A-Z0-9]{5})$/;

    public licenseKey: string;
    public licenseKeyPattern: RegExp;

    constructor(name?: string, public description?: string, pattern?: RegExp) {
        super(name, description);
        this.licenseKeyPattern = pattern;
    }

    public getCustomSetupName(): string {
        return super.getCustomSetupName();
    }

    public coincideWith(customSetup: ExpressCustomSetup): void {
        super.coincideWith(customSetup);
        if (this.customSetupType === customSetup.customSetupType) {
            const setup = customSetup as LicensedComponentSetup;
            this.licenseKey = setup.licenseKey;
        }
    }

    public validate(): boolean {
        return super.validate() && (!isLicensedComponent(this.componentName) || this.isValidLicenseKey());
    }

    private isValidLicenseKey(): boolean {
        if (stringIsNullOrEmpty(this.licenseKey)) {
            return false;
        }
        if (this.componentName === supportedComponentNames.XtractIS) {
            // always true if the license key is extracted from license file for Xtract IS
            return true;
        }
        return this.licenseKey.indexOf(' ') === -1 && (this.licenseKeyPattern ? this.licenseKeyPattern.test(this.licenseKey) : true);
    }
}
